(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  if (!customElements.get('ls-product-row')) {
    customElements.define('ls-product-row', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ls-category-track');
        if (!this.track) return;
        this.cleanup = new AbortController();
        const options = { signal: this.cleanup.signal };
        const update = () => {
          const cards = [...this.track.children];
          const step = cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : 1;
          const index = Math.min(cards.length, Math.max(1, Math.round(this.track.scrollLeft / step) + 1));
          const status = this.querySelector('.ls-row-position');
          if (status) status.textContent = index + ' of ' + cards.length;
          const previous = this.querySelector('[data-row-step="-1"]');
          const next = this.querySelector('[data-row-step="1"]');
          if (previous) previous.disabled = this.track.scrollLeft < 2;
          if (next) next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        };
        this.track.addEventListener('scroll', update, { ...options, passive: true });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-row-step]');
          if (!button || !this.contains(button)) return;
          const cards = this.track.children;
          const step = cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : this.track.clientWidth;
          this.track.scrollBy({ left: Number(button.dataset.rowStep) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, options);
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const button = this.querySelector(event.key === 'ArrowLeft' ? '[data-row-step="-1"]' : '[data-row-step="1"]');
          button?.click();
        }, options);
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        update();
      }
      disconnectedCallback() { this.cleanup?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
